import { useEffect, useState } from 'react';
import type { User } from '@/shared/schema';
import { getAuth, subscribeAuth } from '@/lib/authStore';

export function useStoredAuth() {
  const [user, setUser] = useState<User | null>(() => getAuth());

  useEffect(() => {
    const unsubscribe = subscribeAuth((u) => setUser(u));
    return unsubscribe;
  }, []);

  return {
    user,
    isAuthenticated: !!user,
    isLoading: false,
  };
}
